/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import IntructionVideoAPI from '@/api/IntructionVideoAPI.js';
import { NumberRetry, NumberTimeOutRetry } from '@/api/base/base-api';

import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { MSEnum } from '../../common/enumeration';
import i18n from '@/i18n/i18n';

export default {
	getTotalVideoIntruction: async function(context, payload) {
		let res = await httpClient.getAsync(
			{ url: IntructionVideoAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/total' },
			false
		);
		if (res && res.Data) {
			context.commit('updateIntructionVideoTotal', res.Data);
			return res.Data;
		}
		return 0;
	},

	loadIntructionVideo: async function(context, payload) {
		let res = await httpClient.postAsync(
			{ url: IntructionVideoAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/paging', data: payload },
			true
		);
		if (res && res.Data && res.Data.length > 0) {
			return res.Data;
		}
		return null;
	},

	getIntructionVideoByTypeAsync: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url:
					IntructionVideoAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) +
					`/getbytype?type=${payload.type}&isPrioritize=${payload.isPrioritize}`
			},
			false
		);
		if (res && res.Data) {
			return res.Data;
		}
		return null;
	},

	getVideoForSubType: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url:
					IntructionVideoAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) +
					`/getvideoforsubtype?type=${payload.type}&subtype=${payload.subType}`
			},
			false
		);
		if (res && res.Data) {
			return res.Data;
		}
		return null;
	}
};
